import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import '@/assets/css/animate.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fontsource/poppins';
import '@fontsource-variable/tilt-warp';
import '@fontsource/bowlby-one';

import route from './route';
import NewNav from '@/components/NewNav';
import BottomPage from '@/components/BottomNew';
import { getCurrentLanguage } from "@/store/data/global";

// 不需要滚动到顶部的页面路径
const NO_NEED_TOP_PATHS = [];

// 自定义Hook：监听窗口大小变化并设置CSS变量
const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setSize({ width, height });

      document.documentElement.style.setProperty('--vw', `${width / 100}px`);
      document.documentElement.style.setProperty('--vh', `${height / 100}px`);
      document.documentElement.style.setProperty('--window-width', `${width}px`);
      document.documentElement.style.setProperty('--window-height', `${height}px`);

      const baseSize = 14;
      let fontSize = baseSize;
      if (width >= 1920) fontSize = baseSize + 4;
      else if (width >= 1200) fontSize = baseSize + 2;
      else if (width < 768) fontSize = baseSize - 1;

      document.documentElement.style.setProperty('--root-font-size', `${fontSize}px`);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return size;
};

// 路由渲染组件
const RouteRenderer = () => {
  const location = useLocation();
  const routes = useRoutes(route);
  const currentLanguage = useSelector(getCurrentLanguage);

  useEffect(() => {
    const currentPath = location?.pathname || '';
    const shouldScrollToTop = !NO_NEED_TOP_PATHS.some(path =>
      currentPath.includes(path)
    );

    if (shouldScrollToTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname, currentLanguage]);

  return routes;
};

// 全局 hash 锚点跳转处理器（关键修复！）
const HashScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');

      const tryScroll = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
          setTimeout(() => {
            element.style.backgroundColor = '';
          }, 2000);
        } else {
          // 组件还没渲染出来，继续等（最多等2秒）
          setTimeout(tryScroll, 100);
        }
      };

      // 延迟一点执行，确保懒加载组件已开始渲染
      setTimeout(tryScroll, 200);
    }
  }, [location.pathname, location.hash]); // 关键：监听 hash 变化

  return null;
};

// 主内容
const AppContent = () => {
  useWindowSize();

  return (
    <>
      <NewNav />
      <div className='app_warp' style={{ minHeight: "calc(100vh - 125px)" }}>
        <Suspense fallback={<div className="page-loading">Loading...</div>}>
          <RouteRenderer />
          {/* 全局锚点处理器，放这里确保所有页面都能用 */}
          <HashScrollHandler />
        </Suspense>
      </div>
      <BottomPage key="global-footer" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;